import { useQuery } from "@tanstack/react-query";
import { revenueApi } from "@/lib/api";
import { POLLING_INTERVAL } from "@/hooks/useInterval";

/**
 * One royalty statement, kept fresh while its revenue CSV is still being
 * prepared so a download waiting on it enables itself once it is ready.
 */
export function useRoyaltyStatement(id: string | undefined) {
  const { data, isLoading } = useQuery({
    queryKey: ["royalty-statement", id],
    queryFn: () => revenueApi.getRoyaltyStatement(id!),
    enabled: !!id,
    refetchInterval: (query) =>
      query.state.data?.revenue_csv_status === "preparing" ? POLLING_INTERVAL : false,
  });

  return { statement: data, isLoading };
}
